import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { Notification } from './notification.model';

export interface NotificationState extends EntityState<Notification> {}

@Injectable()
@StoreConfig({
  name: 'notification',
  resettable: true,
  idKey: 'id',
})
export class NotificationStore extends EntityStore<NotificationState> {
  constructor() {
    super();
  }
}
